import { Link } from "react-router-dom";

export default function HomeCTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2ee169879851752ed6f2cf845026418a.jpg"
          alt="Piso vaciado listo para vender o alquilar en Girona"
          title="Vaciado de pisos en Girona - piso listo para vender o alquilar - GIROBUIT"
          className="w-full h-full object-cover object-top"
          width={1920}
          height={600}
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-[#330000]/80"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-block text-xs font-700 text-[#FF6666] uppercase tracking-widest mb-4" style={{ fontWeight: 700 }}>
          Actúa ahora
        </span>
        <h2 className="text-3xl md:text-5xl font-900 text-white mb-6" style={{ fontWeight: 900 }}>
          ¿Necesitas vaciar un piso o local en Girona?
        </h2>
        <p className="text-red-200 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Pide tu <strong className="text-white">presupuesto sin compromiso</strong> hoy mismo. Respondemos en menos de 24 horas y podemos empezar cuando tú lo necesites.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
          <a
            href="tel:+34602365996"
            className="flex items-center justify-center gap-3 bg-[#ff0000] text-white px-8 py-4 rounded-full text-base font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#cc0000] hover:scale-105 w-full sm:w-auto"
            style={{ fontWeight: 700, boxShadow: "0 4px 20px rgba(255,0,0,0.4)" }}
          >
            <i className="ri-phone-fill text-lg"></i> Llamar: 602 36 59 96
          </a>
          <Link
            to="/contacto"
            className="flex items-center justify-center gap-3 bg-white/15 border-2 border-white/40 text-white px-8 py-4 rounded-full text-base font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-white/25 hover:scale-105 w-full sm:w-auto"
            style={{ fontWeight: 700 }}
          >
            <i className="ri-mail-send-line text-lg"></i> Enviar mensaje
          </Link>
        </div>
      </div>
    </section>
  );
}
